import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import cookie from 'react-cookies';


export default class Menu extends Component {

    constructor(props){
        super(props);
        
        this.state = {
            loading: false,
            security: cookie.load('user'),
            roles: [],
            menu: this.props.menus
        } 
    }

    getUrlAgrupador = (agrupador = "") => {
        switch(agrupador) {
            case "Administradores":
                return "/administradores";
            case "Usuarios":
                return "/permisos"
            case "Reportes":
                return "/reportes"
            case "Configuradores":
                return "/configuradores"
            case "Boletín de Inteligencia":
                return "/boletin"
            case "Recursos":
                return "/recurso"
            case "Eventos":
                return "/eventos"
            case "Productos":
                return "/ficha-producto"
            case "Paises":
                return "/ficha-pais"
            // default:
            //   return "/boletin";
        }
    } 
	  
    render() {
      return (
        this.state.security.cRolesxUsuario != null ?

          <div className="divContenidoPanelNav">
              <div className="divClosePanelNav" />
              <div className="divSearchNav">
                <input 
                  type="text" 
                  placeholder="Buscar..." 
                  id="txtBuscarMenu" 
                />
                <input 
                  type="submit" 
                  defaultValue="Buscar" 
                />
              </div>

              <div className="scrollgeneral divHeightMenu">
                  {this.state.menu.map((resource) => (
                        <React.Fragment key={resource.sAgrupador}>
                          <div className="lblTituloNav">
                            {resource.sAgrupador}
                          </div>	
                          <div className="divItemNav">
                            { 
                              resource.sMenu.length > 1 &&
                              resource.sMenu.map((option, index) => {
                                let url = this.getUrlAgrupador(resource.sAgrupador);

                                if(option.sUrl !== url){
                                  return (
                                    <Link key={index} to={option.sUrl} className="linkMenu">
                                        {option.sOpcNombre}
                                    </Link>
                                  )
                                }
                              })
                            }

                            { 
                              resource.sMenu.length == 1 &&
                              resource.sMenu.map((option, index) => {
                                
                                  return (
                                    <Link key={index} to={option.sUrl} className="linkMenu">
                                        {option.sOpcNombre}
                                    </Link>
                                  )
                                
                              })
                            }
                          </div>
                        </React.Fragment>
                    ))
                  }
              </div>
          </div>

        :

          <div>
            <ul className="navbar-nav sidebar sidebar-dark accordion" id="accordionSidebar">
                <a className="sidebar-brand d-flex align-items-center justify-content-center">
                <div className="sidebar-brand-icon">
                    <img src="../images/logo.png" alt="" />
                </div>
                </a>
                <li  className="sidebar__option">
                    <div> <b> No tiene Roles asignados </b></div>
                </li>
            </ul>
          </div>

    )}
}
 

